import React from 'react';
import { useTranslation } from 'react-i18next';
import { mockProjects } from '../mock/data';
import { Ship, Anchor, Wind } from 'lucide-react';

const Projects = () => {
  const { t } = useTranslation();

  const getCategoryIcon = (category) => {
    switch(category) {
      case 'fishing': return Ship;
      case 'ferry': return Anchor;
      case 'offshore': return Wind;
      default: return Ship;
    }
  };

  const getCategoryImage = (category) => {
    switch(category) {
      case 'fishing': return 'https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/0bicsbxt_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%282%29.jpeg';
      case 'ferry': return 'https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/8nrcjw5w_image.png';
      case 'offshore': return 'https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/fxe5bwbz_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%283%29.jpeg';
      default: return '';
    }
  };

  const renderProjectCategory = (category, title, description, projects) => {
    const IconComponent = getCategoryIcon(category);
    const categoryImage = getCategoryImage(category);

    // Separate completed and ongoing projects
    const completedProjects = projects.filter(p => p.status === 'completed');
    const ongoingProjects = projects.filter(p => p.status === 'ongoing');

    return (
      <div className="project-category">
        <div className="project-category-header">
          <div className="project-category-icon">
            <IconComponent size={32} />
          </div>
          <div>
            <h2 className="project-category-title">{title}</h2>
            <p className="project-category-description">{description}</p>
          </div>
        </div>

        <div className="project-category-content">
          <div className="project-category-image">
            <img src={categoryImage} alt={title} />
          </div>
          
          <div className="projects-list">
            {/* Completed Projects */}
            {completedProjects.length > 0 && (
              <>
                <div className="project-group-header">
                  <h3>{t('projects.completedProjects')}</h3>
                </div>
                {completedProjects.map((project) => (
                  <div key={project.id} className="project-item">
                    <div className="project-info">
                      <h4 className="project-name">{project.name}</h4>
                      {project.type && <p className="project-type">{project.type}</p>}
                      {project.descKey && <p className="project-description">{t(`projects.${project.descKey}`)}</p>}
                      {project.year && <span className="project-year">{project.year}</span>}
                    </div>
                    <span className={`project-status ${project.status}`}>
                      {t(`projects.${project.status}`)}
                    </span>
                  </div>
                ))}
              </>
            )}

            {/* Ongoing Projects */}
            {ongoingProjects.length > 0 && (
              <>
                <div className="project-group-header">
                  <h3>{t('projects.ongoingProjects')}</h3>
                </div>
                {ongoingProjects.map((project) => (
                  <div key={project.id} className="project-item">
                    <div className="project-info">
                      <h4 className="project-name">{project.name}</h4>
                      {project.type && <p className="project-type">{project.type}</p>}
                      {project.descKey && <p className="project-description">{t(`projects.${project.descKey}`)}</p>}
                      {project.year && <span className="project-year">{project.year}</span>}
                    </div>
                    <span className={`project-status ${project.status}`}>
                      {t(`projects.${project.status}`)}
                    </span>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="page-projects">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">{t('projects.title')}</h1>
          <p className="page-subtitle">{t('projects.subtitle')}</p>
        </div>
      </section>

      <section className="projects-content">
        <div className="container">
          {renderProjectCategory(
            'fishing',
            t('projects.fishing'),
            t('projects.fishingDesc'),
            mockProjects.fishing
          )}

          {renderProjectCategory(
            'ferry',
            t('projects.ferry'),
            t('projects.ferryDesc'),
            mockProjects.ferry
          )}

          {renderProjectCategory(
            'offshore',
            t('projects.offshore'),
            t('projects.offshoreDesc'),
            mockProjects.offshore
          )}
        </div>
      </section>
    </div>
  );
};

export default Projects;
